import _objectSpread2 from "../_virtual/_@oxc-project_runtime@0.150.0/helpers/esm/objectSpread2.js";
//#region src/unpatchedConsole/const.ts
const defaultUnpatchedConsole = _objectSpread2({}, console);
//#endregion
export { defaultUnpatchedConsole };

//# sourceMappingURL=const.js.map